//styles
import Image from "next/image";
import styles from "./iconButton.module.scss";
import { iconButtonPropsType } from "./types";
import classNames from "classnames";
import Loading from "../loading/loading";
import { useCallback } from "react";

const IconButton = ({
  disabled = false,
  loading = false,
  onClick,
  ...otherProps
}: iconButtonPropsType) => {
  const renderIcon = useCallback(() => {
    if (loading) {
      return <Loading />;
    } else {
      return (
        <>
          {!loading && disabled ? (
            <Image
              height={18}
              width={18}
              alt="arrow"
              src={"/icons/common/arrow-right-gray.svg"}
            />
          ) : (
            <Image
              height={18}
              width={18}
              alt="arrow"
              src={"/icons/common/arrow-right.svg"}
            />
          )}
        </>
      );
    }
  }, [disabled, loading]);

  return (
    <button
      className={classNames(styles.container, !disabled && styles.active)}
      onClick={(e) => {
        !disabled && onClick && onClick(e);
      }}
      {...otherProps}
    >
      {renderIcon()}
    </button>
  );
};

export default IconButton;
